import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { PLATFORM_COMPARISON } from "@/data/content";

const FLOW_LABELS = [
  "Renewable Generation",
  "Energy Management",
  "Battery Buffer + Hydrogen System",
  "Farm Loads",
];

export const PlatformConfig = () => (
  <section data-testid="platform-config-section" className="bg-glacier px-6 py-[30px] sm:py-[40px] lg:px-12 lg:py-[70px]">
    <div className="lg:mx-auto lg:max-w-[1280px]">
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.6 }}
        className="max-w-2xl lg:max-w-none"
      >
        <h2
          data-testid="platform-config-headline"
          className="font-heading text-[30px] font-semibold leading-tight text-ink sm:text-[35px] lg:whitespace-nowrap lg:text-[41px]"
        >
          The power class is only the starting point
        </h2>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.6, delay: 0.1 }}
        data-testid="platform-config-flow"
        className="mt-[43px] flex flex-wrap items-center gap-x-3 gap-y-3 lg:mt-16"
      >
        {FLOW_LABELS.map((label, i) => (
          <span key={label} className="flex items-center gap-3">
            <span className="text-sm font-medium text-ink sm:text-base">{label}</span>
            {i !== FLOW_LABELS.length - 1 && (
              <ArrowRight size={15} className="shrink-0 text-teal" aria-hidden="true" />
            )}
          </span>
        ))}
      </motion.div>

      <div className="mt-11 grid grid-cols-1 gap-10 border-t border-borderLight pt-9 sm:grid-cols-2 sm:divide-x sm:divide-borderLight lg:mt-12 lg:gap-16 lg:pt-11">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.5 }}
          data-testid="platform-config-standardized"
        >
          <span className="text-xs font-medium uppercase tracking-[0.12em] text-inkMuted">
            {PLATFORM_COMPARISON.standardized.title}
          </span>
          <p className="mt-2 text-sm leading-relaxed text-inkSoft">{PLATFORM_COMPARISON.standardized.intro}</p>
          <ul className="mt-4 space-y-3">
            {PLATFORM_COMPARISON.standardized.items.map((item) => (
              <li key={item} className="text-lg text-ink lg:text-xl">
                {item}
              </li>
            ))}
          </ul>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.5, delay: 0.08 }}
          data-testid="platform-config-configured"
          className="sm:pl-10 lg:pl-16"
        >
          <span className="text-xs font-medium uppercase tracking-[0.12em] text-inkMuted">
            {PLATFORM_COMPARISON.configured.title}
          </span>
          <p className="mt-2 text-sm leading-relaxed text-inkSoft">{PLATFORM_COMPARISON.configured.intro}</p>
          <ul className="mt-4 space-y-3">
            {PLATFORM_COMPARISON.configured.items.map((item) => (
              <li key={item} className="text-lg text-ink lg:text-xl">
                {item}
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
    </div>
  </section>
);
